/* eslint eqeqeq: "off" */
import "./spinner.css";
import PropTypes from "prop-types";

const Spinners = (props) => (
  <div
    className={
      props.mode == "import" ? "fallback-import-spinner" : "fallback-spinner"
    }
  >
    <div
      className={
        props.type == "Transactions" && props.collapsed === true
          ? "transaction-collpased-loading"
          : props.type == "Transactions" && props.collapsed === false
          ? "transaction-loading"
          : "loading component-loader"
      }
    >
      <div className="effect-1 effects" />
      <div className="effect-2 effects" />
      <div className="effect-3 effects" />
    </div>
  </div>
);

Spinners.propTypes = {
  mode: PropTypes.any,
  type: PropTypes.any,
  collapsed: PropTypes.any,
};

export default Spinners;
